import { defineComponent as z, computed as u, watch as E, useTemplateRef as L, createBlock as p, openBlock as s, unref as a, withCtx as v, createVNode as c, createElementBlock as n, Fragment as d, createElementVNode as i, createTextVNode as T, toDisplayString as W, createCommentVNode as h, renderList as k } from "vue";
import { ScalarPopover as q, ScalarButton as F, ScalarIcon as x, ScalarFloatingBackdrop as I, ScalarDropdownDivider as M } from "@scalar/components";
import { emitCustomEvent as P } from "@scalar/workspace-store/events";
import { useLayout as $ } from "../../hooks/useLayout.js";
import { useWorkspace as j } from "../../store/store.js";
import y from "./ServerDropdownItem.vue.js";
const R = ["onClick"], G = { class: "flex h-4 w-4 items-center justify-center" }, Z = /* @__PURE__ */ z({
  __name: "ServerDropdown",
  props: {
    collection: {},
    operation: {},
    server: {},
    target: {}
  },
  setup(l) {
    const { layout: w } = $(), { servers: m, collectionMutators: U, events: C, serverMutators: A } = j(), f = u(
      () => {
        var e, r;
        return (r = (e = l.operation) == null ? void 0 : e.servers) == null ? void 0 : r.map((t) => {
          var o;
          return {
            id: t,
            label: ((o = m[t]) == null ? void 0 : o.url) ?? "Unknown server"
          };
        });
      }
    ), b = u(
      () => {
        var e, r;
        return (
          // Filters out servers already present in the request
          (r = (e = l.collection) == null ? void 0 : e.servers) == null ? void 0 : r.filter((t) => {
            var o, g;
            return !((g = (o = l.operation) == null ? void 0 : o.servers) != null && g.includes(t));
          }).map((t) => {
            var o;
            return {
              id: t,
              label: ((o = m[t]) == null ? void 0 : o.url) ?? "Unknown server"
            };
          })
        );
      }
    ), D = u(
      () => {
        var e, r;
        return ((e = f.value) == null ? void 0 : e.length) && ((r = b.value) == null ? void 0 : r.length);
      }
    );
    E([() => l.collection, () => l.operation], ([e, r]) => {
      var o;
      if (!e || e.selectedServerUid || r != null && r.selectedServerUid)
        return;
      const t = (o = l.collection.servers) == null ? void 0 : o[0];
      t && U.edit(l.collection.uid, "selectedServerUid", t);
    });
    const B = () => C.commandPalette.emit({
      commandName: "Add Server"
    }), N = u(() => {
      var e, r, t;
      return (r = (e = l.server) == null ? void 0 : e.url) != null && r.endsWith("/") ? l.server.url.slice(0, -1) : ((t = l.server) == null ? void 0 : t.url) || "";
    }), S = (e, r) => {
      var o;
      if (!l.server)
        return;
      const t = l.server.variables || {};
      t[e] = { ...t[e], default: r }, A.edit(l.server.uid, "variables", t), P(
        (o = V.value) == null ? void 0 : o.$el,
        "scalar-update-selected-server-variables",
        { key: e, value: r }
      );
    }, V = L("wrapper-ref");
    return (e, r) => (s(), p(a(q), {
      ref: "wrapper-ref",
      class: "max-h-[inherit] p-0 text-base",
      focus: "",
      offset: 0,
      placement: "bottom-start",
      resize: "",
      target: e.target,
      teleport: `#${e.target}`
    }, {
      popover: v(({ close: t }) => [
        i("div", {
          class: "custom-scroll flex max-h-[inherit] flex-col gap-1 border-t p-1",
          onClick: t
        }, [
          (s(!0), n(d, null, k(f.value, (o) => (s(), p(y, {
            key: o.id,
            collection: e.collection,
            operation: e.operation,
            server: e.server,
            serverOption: o,
            type: "request",
            "onUpdate:variable": S
          }, null, 8, ["collection", "operation", "server", "serverOption"]))), 128)),
          D.value ? (s(), n(d, { key: 0 }, [
            c(a(M)),
            r[2] || (r[2] = i("div", { class: "text-xxs text-c-2 px-2.5 py-1" }, "Collection", -1))
          ], 64)) : h("", !0),
          (s(!0), n(d, null, k(b.value, (o) => (s(), p(y, {
            key: o.id,
            collection: e.collection,
            operation: e.operation,
            server: e.server,
            serverOption: o,
            type: "collection",
            "onUpdate:variable": S
          }, null, 8, ["collection", "operation", "server", "serverOption"]))), 128)),
          a(w) !== "modal" ? (s(), n("button", {
            key: 1,
            class: "text-xxs hover:bg-b-2 flex cursor-pointer items-center gap-1.5 rounded p-1.75",
            type: "button",
            onClick: B
          }, [
            i("div", G, [
              c(a(x), {
                icon: "Add",
                size: "sm"
              })
            ]),
            r[3] || (r[3] = i("span", null, "Add Server", -1))
          ])) : h("", !0)
        ], 8, R)
      ]),
      backdrop: v(() => [
        c(a(I), { class: "-top-(--scalar-address-bar-height) rounded-lg" })
      ]),
      default: v(() => [
        c(a(F), {
          class: "z-context-plus hover:bg-b-2 font-code text-c-2 ml-0.75 h-auto gap-0.75 rounded border px-1.5 text-base whitespace-nowrap",
          variant: "ghost"
        }, {
          default: v(() => {
            var t;
            return [
              (t = e.operation) != null && t.selectedServerUid || e.collection.selectedServerUid ? (s(), n(d, { key: 0 }, [
                r[0] || (r[0] = i("span", { class: "sr-only" }, "Server:", -1)),
                T(" " + W(N.value), 1)
              ], 64)) : (s(), n(d, { key: 1 }, [
                r[1] || (r[1] = i("span", { class: "sr-only" }, "Add Server", -1)),
                c(a(x), {
                  icon: "Add",
                  size: "xs"
                })
              ], 64))
            ];
          }),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["target", "teleport"]));
  }
});
export {
  Z as default
};
